import React from 'react'

export default ({ fill = '#FFFFFF' }) => (
    <svg width="45" height="45" viewBox="0 0 45 45" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill={fill} d="M42.5156 0H2.48438C1.11188 0 0 1.11188 0 2.48438V42.5175C0 43.8881 1.11188 45 2.48438 45H24.0375V27.5738H18.1725V20.7825H24.0375V15.7744C24.0375 9.96187 27.5869 6.79688 32.7731 6.79688C35.2575 6.79688 37.3913 6.9825 38.0138 7.065V13.14L34.4175 13.1419C31.5975 13.1419 31.0519 14.4825 31.0519 16.4475V20.7844H37.7775L36.9019 27.5756H31.0519V45H42.5194C43.8881 45 45 43.8881 45 42.5156V2.48438C45 1.11188 43.8881 0 42.5156 0V0Z"/>
    </svg>
)
